<div class="dialog-background">
  <div class="row">
    <span class="w-auto hint-color">{{ title }} Hint: </span>
    <button (click)="onCloseClicked()" class="btn-close align-items-end"></button>
  </div>
  <span class="content-center black">{{ content }}</span>
</div>
